import { errorService } from '@ui-furniture/common/services/error';

export class AsyncQueue {
  private readonly _queue: Array<() => Promise<any>> = [];
  private _isProcessing = false;

  private _tryNextAction = async () => {
    this._isProcessing = true;
    const action = this._queue.shift();
    if (action) {
      await action();
      await this._tryNextAction();
    } else this._isProcessing = false;
  };

  push = (action: () => Promise<any>) => {
    this._queue.push(action);
    if (!this._isProcessing)
      this._tryNextAction().catch((err) => errorService.captureException(err));
  };
}
